import React from "react";
import { permissions } from "./constants/Permissions";
import { decrypt } from "./others";

const checkPermission = (feature, role) => {
  const allowed = permissions[role] || [];
  return allowed.includes(feature);
};

export const useHasPermission = () => {
  const roles = decrypt(localStorage.getItem("user"));

  return (feature) => checkPermission(feature, roles.role);
};
